export function formatDate(date: Date) {
  const d = date.getDate()

  return d > 9 ? d : '0' + d
}
